export default __webpack_public_path__ + "static/media/article_image_default_min.5f44e6f8.png";